import { css } from '@emotion/css';

export const listContainer = css`
  
  font-size: 18px;
  font-family: "Source Sans Pro", sans-serif;
  margin-left:5vw;
  margin-right:5vw;
  behavior: smooth;
  scroll-behavior: smooth;

  .gambarCover{
    width:calc(150px + 10vw);
    display: flex;
    justify-content: center;
    align-items: center;
    transition: width 0.1s;
  }

  .textKosong{
    font-size: calc(11px + 2vw);
    font-family: "Source Sans Pro", sans-serif;
  }

  .gambarCover: hover{
    width:calc(160px + 10vw);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .isinya{
    justify-content: center;
    align-items: center;
  }

  .ceritanyaCard{
    justify-content: center;
    align-items: center;
  }

  .judulnya{
    width:calc(150px + 10vw);
    text-align: center;
    font-size: calc(20px + 1vw);
    font-family: 'Poppins', sans-serif;
    cursor: pointer;
    transition: font-size 0.1s;
  }

  .judulnya: hover{
    width:calc(150px + 10vw);
    text-align: center;
    font-size: calc(25px + 1vw);
    font-family: 'Poppins', sans-serif;
    cursor: pointer;
  }

  .gambarCover{
    cursor: pointer;
  }

  .buatItem{
    padding-top:calc(10px + 2vw);
    padding-bottom:calc(10px + 2vw);
    justify-content: center;
    align-items: flex-start;
    top:0;
    display:flex;
  }
  
`;